
const MIN_CORES = 4;
const MIN_MEMORY_GB = 4;

const SOFTWARE_RENDERERS =
  /swiftshader|llvmpipe|softpipe|basic render|mesa offscreen|virtualbox|vmware|parallels|microsoft remote display|generic renderer/i;

function rendererName(): string | null {
  try {
    const canvas = document.createElement('canvas');
    const gl = (canvas.getContext('webgl') ??
      canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null;
    if (!gl) return null;
    const dbg = gl.getExtension('WEBGL_debug_renderer_info');
    const name = dbg
      ? String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) ?? '')
      : String(gl.getParameter(gl.RENDERER) ?? '');
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return name;
  } catch {
    return null;
  }
}

function canAffordBlur(): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  const supported =
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    (CSS.supports('backdrop-filter', 'blur(1px)') ||
      CSS.supports('-webkit-backdrop-filter', 'blur(1px)'));
  if (!supported) return false;

  if (window.matchMedia?.('(prefers-reduced-transparency: reduce)').matches) return false;

  const cores = navigator.hardwareConcurrency;
  if (typeof cores === 'number' && cores > 0 && cores < MIN_CORES) return false;

  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  if (typeof memory === 'number' && memory > 0 && memory < MIN_MEMORY_GB) return false;

  const renderer = rendererName();
  if (renderer === null || SOFTWARE_RENDERERS.test(renderer)) return false;

  return true;
}

export function initVisualEffects(): void {
  if (typeof document === 'undefined') return;
  const apply = () => {
    document.documentElement.setAttribute('data-fx', canAffordBlur() ? 'blur' : 'flat');
  };
  if (typeof requestIdleCallback === 'function') requestIdleCallback(apply, { timeout: 1000 });
  else setTimeout(apply, 0);
}
